/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![MobilePhoneXIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABKElEQVR4nM2VwUoDQQyGqwffYKu+itT7Is0kcwhJse+yR9eX8E16EC+CiFA99AX0NSrZ7uhQq7vTabEDYWEnky9/ZuAfDP5jMfOJI7kFlA9HuvwrgOTdkdZ2pjfADnQVdj+j7g1ou1oiykVX7pgmo6AkRUHT1b7yUw4cZQMcygOQPJbMRdj3fjoEkhcgXVRVdZwJ0Od2xvOmMOipI3lr/z1lK/B+OgwFV9+v4vOgKvsOvEFQX7/fvi6umM9+y08GlMzFOsD76/OdAErmwsaxPiL7mrJsgEOZhYJ2we0LaoBAep8NANI7KxS6DaoMbHvZgD7rcAFjmoy6chHlcmtAahw2ACNvCB6wNSAYThzxfcRzj61zr5YJqDe9ASvT13qTkk2dJ5v+LtcndQuVPEBASpYAAAAASUVORK5CYII=)
 */
export const MobilePhoneXIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M8.3 6.3a1 1 0 0 1 1.4 0L12 8.58l2.3-2.3a1 1 0 1 1 1.4 1.42L13.42 10l2.3 2.3a1 1 0 0 1-1.42 1.4L12 11.42l-2.3 2.3a1 1 0 0 1-1.4-1.42L10.58 10l-2.3-2.3a1 1 0 0 1 0-1.4Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M8 1a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3H8Zm3 18a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2ZM7 4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V4Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
